import React from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaStore, FaHeart, FaShieldAlt, FaGift, FaStar } from 'react-icons/fa';
import RecommendedPostings from './RecommendedPostings';

const GuestHomeSections = () => (
  <>
    {/* How it works */}
    <section className="homeHowItWorksSection">
      <div className="mainSection">
        <h2 className="homeSectionTitle">How It Works</h2>
        <p className="homeSectionSubtitle">Discover local sellers and order amazing treats in three simple steps</p>
        <div className="homeHowItWorksGrid">
          <div className="homeHowItWorksCard">
            <div className="homeHowItWorksIcon">
              <FaSearch />
            </div>
            <h3>1. Browse & Search</h3>
            <p>Explore products from local sellers. Filter by category, delivery options, and more.</p>
          </div>
          <div className="homeHowItWorksCard">
            <div className="homeHowItWorksIcon">
              <FaStore />
            </div>
            <h3>2. Order from Sellers</h3>
            <p>Add to cart and checkout securely. Connect directly with sellers for custom orders.</p>
          </div>
          <div className="homeHowItWorksCard">
            <div className="homeHowItWorksIcon">
              <FaGift />
            </div>
            <h3>3. Enjoy or Gift</h3>
            <p>Get delivery or pickup. Perfect for yourself or as a thoughtful gift for loved ones.</p>
          </div>
        </div>
      </div>
    </section>

    {/* Recommended products for guests */}
    <RecommendedPostings />

    {/* Trust & Benefits */}
    <section className="homeTrustSection">
      <div className="mainSection">
        <h2 className="homeSectionTitle">Why Shop with Chocowi</h2>
        <div className="homeTrustGrid">
          <div className="homeTrustCard">
            <FaShieldAlt className="homeTrustIcon" />
            <h3>Trusted Sellers</h3>
            <p>All sellers are verified. Shop with confidence from your local community.</p>
          </div>
          <div className="homeTrustCard">
            <FaStar className="homeTrustIcon" />
            <h3>Real Reviews</h3>
            <p>Read genuine reviews from other buyers before you order.</p>
          </div>
          <div className="homeTrustCard">
            <FaHeart className="homeTrustIcon" />
            <h3>Support Local</h3>
            <p>Support small businesses and artisans in your area.</p>
          </div>
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="homeCtaSection">
      <div className="mainSection">
        <div className="homeCtaCard">
          <h2>Ready to Discover?</h2>
          <p>Join thousands of happy customers. Create an account to browse products, save favorites, and place orders.</p>
          <div className="homeCtaButtons">
            <Link to="/signup" className="homeCtaPrimary">Create Account</Link>
            <Link to="/signin" className="homeCtaSecondary">Sign In</Link>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default GuestHomeSections;
